import { render, staticRenderFns } from "./SortMenuBtn.vue?vue&type=template&id=8468b614&"
import script from "./SortMenuBtn.vue?vue&type=script&lang=js&"
export * from "./SortMenuBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports